import { BlogPosting, NewsArticle, WithContext } from 'schema-dts'

import { localBusiness, organization } from '@/common/json-ld/organization'
import { contextUrl, getAbsoluteUrl } from '@/common/json-ld/util'
import { Post } from '@/common/models/data/dashboard/posts/post'

type SchemaPost = BlogPosting | NewsArticle

const post = (post: Post, url: string): WithContext<SchemaPost> => {
    const data: Partial<SchemaPost> = {
        '@type': post.type.type === 'blog' ? 'BlogPosting' : 'NewsArticle',
        'mainEntityOfPage': getAbsoluteUrl(url),
        'url': getAbsoluteUrl(url),
        'name': post.title,
        'headline': post.title,
        'backstory': post.summary,
        'articleBody': post.content,
        'image': post.image,
        'keywords': post.tagged.map(tagged => {
            return tagged.tag_name
        }),
        'datePublished': post.published_at,
        'dateModified': post.updated_at,
        'author': {
            '@type': 'Person',
            'name': post.author.name,
            'affiliation': localBusiness()
        },
        'publisher': organization(),
    }

    if (post.hasRating && post.rating !== null) {
        data.contentRating = post.rating.toString()
    }

    if (post.category) {
        data.articleSection = post.category.category
    }

    return {
        '@context': contextUrl,
        ...data
    } as WithContext<SchemaPost>
}

const postPreview = (post: Post, url: string): WithContext<SchemaPost> => {
    const data: Partial<SchemaPost> = {
        '@type': post.type.type === 'blog' ? 'BlogPosting' : 'NewsArticle',
        'mainEntityOfPage': getAbsoluteUrl(url),
        'url': getAbsoluteUrl(url),
        'name': post.title,
        'headline': post.title,
        'backstory': post.summary,
        'image': post.image,
        'keywords': post.tagged.map(tagged => {
            return tagged.tag_name
        }),
        'datePublished': post.published_at,
        'dateModified': post.updated_at,
        'author': {
            '@type': 'Person',
            'name': post.author.name,
            'affiliation': localBusiness()
        },
        'publisher': organization()
    }

    if (post.hasRating && post.rating !== null) {
        data.contentRating = post.rating.toString()
    }

    if (post.category) {
        data.articleSection = post.category.category
    }

    return {
        '@context': contextUrl,
        ...data
    } as WithContext<SchemaPost>
}

export {
    post, postPreview
}
